import { useQueryWithUserId } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IEntMyRequestsListItem } from '../types';

/**
 * Query key for tracking enterprise my requests list caching.
 */
export const FETCH_ENT_MY_REQ_LIST_QUERY_KEY =
  'enterprise-my-requests-list-query-key';

/**
 * It returns the query for the mock enterprise requests data.
 */
export function useEnterpriseMyRequestsListQuery() {
  /**
   * Cache stale time for the enterprise requests details to 30 seconds.
   */
  const CACHE_STALE_TIME = 30000;

  return useQueryWithUserId<IEntMyRequestsListItem[], IApiError>({
    queryKey: [FETCH_ENT_MY_REQ_LIST_QUERY_KEY],
    queryFn: () => B2B_SERVICE_API.fetchEntMyRequestsList(),
    staleTime: CACHE_STALE_TIME,
  });
}
